import { render, staticRenderFns } from "./BarcodeScanner.vue?vue&type=template&id=512049b8&scoped=true&"
import script from "./BarcodeScanner.vue?vue&type=script&lang=js&"
export * from "./BarcodeScanner.vue?vue&type=script&lang=js&"
import style0 from "./BarcodeScanner.vue?vue&type=style&index=0&id=512049b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512049b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('512049b8')) {
      api.createRecord('512049b8', component.options)
    } else {
      api.reload('512049b8', component.options)
    }
    module.hot.accept("./BarcodeScanner.vue?vue&type=template&id=512049b8&scoped=true&", function () {
      api.rerender('512049b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Stamp/components/BarcodeScanner.vue"
export default component.exports